/* globals google */

import $ from "jquery";

let markers = [];
/**
 * @var {array} openedInfoWindows Track info windows we might need to close.
 */
let openedInfoWindows = [];
// start the map
let map;

// Set info window for each marker.
function bindInfoWindow(marker, markerMap, markerInfoWindow) {
	marker.addListener("click", function () {
		closeOtherWindows();
		// infowindow.content; // 'content' is an element of infowindow
		markerInfoWindow.open(markerMap, this);
		openedInfoWindows[0] = markerInfoWindow;
	});
}

// Function to close opened windows.
function closeOtherWindows() {
	if (openedInfoWindows.length > 0) {
		openedInfoWindows[0].close();
		openedInfoWindows.length = 0; // reset the array count to 0
	}
}

export function initMap() {
	$(function () {
		$("#volunteerProjects .accordion-item").each(function (index) {
			let title = $(this).find(".project-title");
			// let body = $(this).find(".accordion-body");
			let latlong = title.data("latlong");
			let img = title.data("img");
			if (!img) {
				img = "/wp-content/themes/iscbc-theme/assets/img/iscbc-logo-big.png";
			}
			let lat = latlong.split(",")[0];
			let long = latlong.split(",")[1];
			let description = $(this).find(".project-description");

			let marker = {
				title: title.text(),
				desc: description.text(),
				coordinates: {
					lat: lat,
					lng: long,
				},
				content:
					`<div id="infowindow_${index}" class="infowindow">` +
					'<div class="siteNotice">' +
					"</div>" +
					`<h5>${title.text()}</h5>` +
					"<div>" +
					`<img src="${img}" class="project_image"/>` +
					`<div class="project_description">${description.html()}</div> <!-- end project_description -->` +
					"</div>" +
					"</div>",
				id: index,
			};
			markers.push(marker);
		});
		// The map, centered on BC
		map = new google.maps.Map(document.getElementById("map"), {
			zoom: 6,
			center: {
				lat: 51.458175,
				lng: -120.267383,
			},
		});
		// make sure at least 1 marker exists
		const markerIconSrc = "/wp-content/themes/iscbc-theme/assets/img/flag.png";
		if (markers.length > 0) {
			// loop through the markers array and create a marker for each set of coordinates
			for (var i = 0; i < markers.length; i++) {
				const data = markers[i];
				const { title, coordinates, content } = data;
				// generate latitude and longtitude position of the marker
				const position = new google.maps.LatLng(coordinates.lat, coordinates.lng);
				// define the marker
				const marker = new google.maps.Marker({ map, position, title, icon: markerIconSrc });
				// info window content
				const infowindow = new google.maps.InfoWindow({ content });

				// bind the info window to the marker
				bindInfoWindow(marker, map, infowindow);
			} // end markers loop
		} // end markers.length check
	});
}
